import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import CourseCommunityListLayer from "../components/CourseCommunityList";
 
 
const CourseCommunityListPage = () => {
  return (
    <>
    
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Course Communities  </h5><Breadcrumb title="Course Community" /></div>
 
        <CourseCommunityListLayer />

    </>
  );
};
 
export default CourseCommunityListPage;
 
 